/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React from 'react';
import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";
import { useHeaderAggData } from '../../hooks/useHeaderAggData';
import { Spellcheck, LiveHelp } from "@material-ui/icons";

const Header: React.FC<{
  type: 'inf' | 'bulk'
}> = ({ type }) => {
  const { data, isLoading } = useHeaderAggData(type)

  return (
    <>
      <div className="header pb-6 pt-5 pt-md-8"
        style={{
          backgroundColor: '#2D315C',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundImage: "url(/background-header-infinity.jpg)"
        }}
      >
        <span className="mask bg-gradient-default opacity-8" />
        <Container fluid>
          <div className="header-body">
            <Row>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          style={{ fontSize: "10px" }}
                          className="text-uppercase text-muted mb-0"
                        >
                          Total Executions
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                          {isLoading || !data ? '-' : data.numExecs}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                          <Spellcheck />
                        </div>
                      </Col>
                    </Row>
                    {/* <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-success mr-2">
                        <i className="fa fa-arrow-up" /> 3.48%
                      </span>{" "}
                      <span className="text-nowrap">Since last month</span>
                    </p> */}
                  </CardBody>
                </Card>
              </Col>
              {
                typeof data?.numQues === 'number' &&
                <Col lg="6" xl="3">
                  <Card className="card-stats mb-4 mb-xl-0">
                    <CardBody>
                      <Row>
                        <div className="col">
                          <CardTitle
                            tag="h5"
                            style={{ fontSize: "10px" }}
                            className="text-uppercase text-muted mb-0"
                          >
                            Total Questions
                          </CardTitle>
                          <span className="h2 font-weight-bold mb-0">
                            {isLoading || !data ? '-' : data.numQues}
                          </span>
                        </div>
                        <Col className="col-auto">
                          <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                            <LiveHelp />
                          </div>
                        </Col>
                      </Row>
                      {/* <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-danger mr-2">
                        <i className="fas fa-arrow-down" /> 3%
                      </span>{" "}
                      <span className="text-nowrap">Since last week</span>
                    </p> */}
                    </CardBody>
                  </Card>
                </Col>
              }
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Header;
